import toast from "react-hot-toast";

export function isNumeric(str) {
    return /^(\+)?\d+$/.test(str.trim());
}

export function showToastByIsSuccess(isSuccess, message) {
    if (isSuccess) {
        toast.success(message, {
            className: "text-12 text-dark-blue-200",
        })
    } else {
        toast.error(message,{
            className: "text-12 text-dark-blue-200",
        })

    }
}